export default "__VITE_ASSET__Brp4cPld__"